export default "__VITE_ASSET__CUFwvLK7__"